import * as React from "react";
import { Button, VStack } from "@chakra-ui/react";
import { AutoComplete, DatePicker, Form, TextInput, Select } from "components";
import { useOrganizationSettings } from "duck";
import { FormValues, FREQUENCY_OPTIONS, getValidation } from "./duck";

interface MedicationFormProps {
  defaultValues: FormValues;
  onSubmit(values: FormValues): Promise<any> | void;
  onCancel(): void;
  submitText?: string;
}

const MedicationForm: React.FC<MedicationFormProps> = ({
  defaultValues,
  onSubmit,
  onCancel,
  submitText = "Add Medication"
}) => {
  const { dateFormat } = useOrganizationSettings();

  return (
    <Form<FormValues>
      {...getValidation()}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
    >
      <VStack spacing={6}>
        <AutoComplete.Medications
          creatable
          name="medication"
          optionValue="name"
          label="Name"
          placeholder="Name"
        />
        <TextInput name="dose" label="Dose" placeholder="Dose" />
        <Select
          name="frequency"
          label="Frequency"
          placeholder="Frequency"
          options={FREQUENCY_OPTIONS}
        />
        <DatePicker
          name="lastGivenAt"
          label="Date and Time of Last Given"
          placeholderText="Date and Time of Last Given"
          maxDate={new Date()}
          dateFormat={`${dateFormat}, h:mm aa`}
          showTimeSelect
        />
      </VStack>

      <Form.Controls submitText={submitText} mt={6}>
        <Button variant="outline" colorScheme="gray" onClick={onCancel}>
          Cancel
        </Button>
      </Form.Controls>
    </Form>
  );
};

export default MedicationForm;
